import { Fetch } from '../utils'
import { ApiEndpoints } from '../constants'
import { MonthlyCashFlowProfile, RetirementGoalAccount } from '..'
import type { GlobalErrorHandler, Goal } from '..'

export class GoalApi {
  fetchInstance: Fetch

  constructor(endpoint: string, token: string, onError?: GlobalErrorHandler) {
    this.fetchInstance = new Fetch(endpoint, token, undefined, onError)
  }

  addGoal = async (goal: Goal) => {
    return this.fetchInstance.post(ApiEndpoints.GOALS, goal).then((data) => data.goal)
  }

  addRetirementGoal = async (goal: Goal) => {
    return this.fetchInstance
      .post(ApiEndpoints.RETIREMENT_GOALS, goal)
      .then((data) => data.retirement_goal)
  }

  addRetirementGoalAccount = async (retirementAccount: RetirementGoalAccount) => {
    return this.fetchInstance
      .post(ApiEndpoints.RETIREMENT_GOAL_ACCOUNTS, retirementAccount)
      .then((data) => data.retirement_goal_account)
  }

  getGoalByGuid = async (guid: string) => {
    return this.fetchInstance.get(`${ApiEndpoints.GOALS}/${guid}`).then((data) => data.goal)
  }

  getGoals = async () => {
    return this.fetchInstance.get(ApiEndpoints.GOALS).then((data) => data.goals)
  }

  getMonthlyCashFlowProfile = async () => {
    return this.fetchInstance
      .get(ApiEndpoints.MONTHLY_CASH_FLOW_PROFILE)
      .then((data) => data.monthly_cash_flow_profile)
  }

  getRetirementGoals = async () => {
    return this.fetchInstance
      .get(ApiEndpoints.RETIREMENT_GOALS)
      .then((data) => data.retirement_goals)
  }

  getRetirementGoalAccounts = async () => {
    return this.fetchInstance
      .get(ApiEndpoints.RETIREMENT_GOAL_ACCOUNTS)
      .then((data) => data.retirement_goal_accounts)
  }

  removeGoal = async (guid: string) => {
    return this.fetchInstance.delete(`${ApiEndpoints.GOALS}/${guid}`).then((data) => data)
  }

  removeRetirementGoal = async (guid: string) => {
    return this.fetchInstance
      .delete(`${ApiEndpoints.RETIREMENT_GOALS}/${guid}`)
      .then((data) => data)
  }

  removeRetirementGoalAccount = async (guid: string) => {
    return this.fetchInstance
      .delete(`${ApiEndpoints.RETIREMENT_GOAL_ACCOUNTS}/${guid}`)
      .then((data) => data)
  }

  reorderGoals = async (goals: Goal[]) => {
    return this.fetchInstance
      .post(`${ApiEndpoints.GOALS}/reposition`, { goals: goals })
      .then((data) => data.goals)
  }

  updateGoal = async (goal: Goal) => {
    return this.fetchInstance
      .put(`${ApiEndpoints.GOALS}/${goal.guid}`, goal)
      .then((data) => data.goal)
  }

  updateMonthlyCashFlowProfile = async (profile: MonthlyCashFlowProfile) => {
    return this.fetchInstance
      .put(`${ApiEndpoints.MONTHLY_CASH_FLOW_PROFILE}`, profile)
      .then((data) => data.monthly_cash_flow_profile)
  }

  updateRetirementGoal = async (goal: Goal) => {
    return this.fetchInstance
      .put(`${ApiEndpoints.RETIREMENT_GOALS}/${goal.guid}`, goal)
      .then((data) => data.retirement_goal)
  }
}
